import { Slider } from '@sunwebgroup/uds-ui/slider'
import { Accordion } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useControlledSliderWithOpenRange, useValueFilter } from '../../../../../domain/hooks'
import { FilterGroupProps } from '../../types'
import { RangeLabel } from './RangeLabel'

export function PricePerPersonFilter({ defaultOpen }: FilterGroupProps) {
  const intl = useIntl()

  const { isFetching, selectedValue, setSelection } = useValueFilter('PricePerPerson')

  const { labelProps, sliderProps } = useControlledSliderWithOpenRange(selectedValue, setSelection)

  return (
    <Accordion.Item title={intl.formatMessage({ id: 'accommodation_price_label' })} defaultOpen={defaultOpen} data-qa="price-per-person-filter">
      <RangeLabel {...labelProps} disabled={isFetching} />
      <Slider {...{ ...sliderProps, withoutIcon: true }} ariaLabel="no-label" disabled={isFetching} data-qa="price-per-person-filter-slider" />
    </Accordion.Item>
  )
}
